import script from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"

import "./BreadCrumb.vue?vue&type=style&index=0&id=3f39000a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f39000a"]])

export default __exports__